<nz-layout class="main-container">
  <app-sidebar />
  <nz-layout class="main-layout">
    <app-header />
    <nz-content [class.mb-120]="!!supportUserData">
      <router-outlet></router-outlet>
    </nz-content>
    <div class="user-info" *ngIf="!!supportUserData">
      <p class="user-email">
        {{
          'You are logged in with Account : ' + (supportUserData.email || '')
        }}
        <br />
        <span nz-tooltip [nzTooltipTitle]="supportUserData.organizationName">
          <ng-container *ngIf="supportUserData.organizationName as orgName">
            Logged in user's school:
            {{
              orgName.length > 99 ? (orgName | slice: 0 : 99) + '...' : orgName
            }}
          </ng-container>
        </span>
      </p>
      <button
        class="primary-text-btn"
        nz-button
        nzType="text"
        (click)="supportUserLogOut()">
        Logout
      </button>
    </div>
  </nz-layout>
  <app-accessibility-panel></app-accessibility-panel>
</nz-layout>
